module.exports = "#user-list {\n  margin-top: 12px;\n  overflow: auto;\n}\n#user-list ngx-datatable {\n  min-width: 1000px;\n}"